module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 019.37c07572.jpg";